"use client";

import { useEffect } from "react";

/* eslint-disable typescript-sort-keys/interface */

type PSearchEvent = {
    event: "psearch";
    siteSearchResults: number;
    siteSearchTerm: string;
};

type FormEvent = {
    event: string;
    etype: string;
    enhanced_conversion_data: {
        email: string;
    };
    customProperties: {
        Target: string[];
    };
};

type TrackingEvent = PSearchEvent | FormEvent;

export const Tracking = (props: { data: TrackingEvent }) => {
    useEffect(() => {
        const win = window as unknown as { dataLayer: TrackingEvent[] };
        win.dataLayer = win.dataLayer || [];
        win.dataLayer.push(props.data);
    }, [props.data]);
    return null;
};
